export const EntitySchema = {
    "users": {
        "entity": "users",
        "id_field": "id_user",
        "ref_field": "display_name",
        "title": "Users",
        "title_singular": "User",
        "rootpath": "/admin/users",
        "defaultPageSize": 20,
        "db": "users",
        "table": "users",
        "privilegies": {
            "list": {
                "groups_can": [1],
            },
            "view": {
                "groups_can": [1],
            },
            "add": {
                "groups_can": [1],
            },
            "update": {
                "groups_can": [1],
            },
            "delete": {
                "groups_can": [1],
            },
        },
    },
}